'use client';

import { useContext } from 'react';
import type { Session } from '@supabase/supabase-js';
import { useAuthStore } from '../stores/authStore';
import { AuthContext } from '../providers/AuthProvider';
import type { User } from '../types/auth';

export interface UseAuthResult {
  user: User | null;
  session: Session | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  initialized: boolean;
  signOut: () => Promise<void>;
}

/**
 * Hook to access authentication state and methods
 * Combines both context and store values for complete auth state
 */
export function useAuth(): UseAuthResult {
  const store = useAuthStore();
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return {
    user: store.user,
    session: context.session,
    isLoading: store.isLoading,
    isAuthenticated: !!store.user,
    initialized: store.initialized,
    signOut: context.signOut,
  };
} 